<template>
  <RevModal
    closable
    :name="DIAGNOSIS_MODALS_NAMES.invoiceRequestPendingModal"
    :title="i18n(translations.title)"
    variant="confirmation"
  >
    <template #body>
      <p class="body-1 mb-12">
        {{ i18n(translations.content1) }}
      </p>
      <p class="body-1 mb-12 mt-24">
        {{ i18n(translations.content2) }}
      </p>
    </template>

    <template #footer>
      <RevButton
        class="mb-12"
        full-width="always"
        variant="primary"
        @click="emit('send-another-invoice-request')"
      >
        {{ i18n(translations.cta1) }}
      </RevButton>
      <RevButton
        class="mb-3"
        data-qa="goto-my-order"
        full-width="always"
        :to="myOrdersLink"
        variant="secondary"
      >
        {{ i18n(translations.cta2) }}
      </RevButton>
    </template>
  </RevModal>
</template>

<script lang="ts" setup>
import { useRouteLocationWithLocale } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { RevButton } from '@ds/components/Button'
import { RevModal } from '@ds/components/Modal'

import { DASHBOARD } from '@/scopes/dashboard/routes'

import { DIAGNOSIS_MODALS_NAMES } from '../name'

import translations from './InvoiceRequestPendingModal.translations'

const emit = defineEmits(['send-another-invoice-request'])

const i18n = useI18n()
const injectLocale = useRouteLocationWithLocale()

const myOrdersLink = toNuxtLink(
  injectLocale({
    type: 'internal',
    name: DASHBOARD.MY_ORDERS.SELF,
  }),
)
</script>
